import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/drift/layer.drift.query.gql"
import type {
  LayerDriftQuery,
  LayerDriftQueryVariables,
} from "@/v2-backoffice-client/layer/drift/__types__/layer.drift.query"

export function useLayerDriftQuery(
  options?: QueryHookOptions<LayerDriftQuery, LayerDriftQueryVariables>,
) {
  return useQuery<LayerDriftQuery, LayerDriftQueryVariables>(query, options)
}
